<template>
  <ul class="action-icon-list__wrapper">
    <li
      v-for="actionIconData in actionIcons"
      :key="actionIconData.actionIcon"
      class="action-icon-list__action-icon-wrapper"
    >
      <a-action-icon
        v-bind="actionIconData"
        :width="35"
        :height="35"
        :title-width="65"
        :open-in-iframe="$helper.isNotAmpPage($route.name)"
        :aria-label="actionIconData.ariaLabel"
        :class="dynamicClass"
        class="action-icon-list__action-icon"
        v-on="$listeners"
      />
    </li>
  </ul>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import AActionIcon from 'shared/AActionIcon'

export default {
  name: 'AActionIconList',
  components: { AActionIcon },
  props: {
    actionIcons: propValidator([PROP_TYPES.ARRAY]),
    titleStaticPosition: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    dynamicClass() {
      return {
        'static-title': this.titleStaticPosition
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.action-icon-list__wrapper {
  display: flex;
  justify-content: flex-start;

  .action-icon-list__action-icon-wrapper {
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }

  .action-icon-list__action-icon {
    display: flex;
    width: 34px;
    height: 34px;
    justify-content: center;
    align-items: center;

    /deep/ .social-sharing__container .a-icon__description {
      &::before {
        width: 115px;
      }
    }
  }
}
</style>
